var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 35,
    viewBox: "0 0 223 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.285 0H59.9558V4.72576H201.285V0Z",
    fill: "url(#paint0_linear_397_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9558 0H40.0325V4.72576H59.9558V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.208 0H201.285V4.72576H221.208V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 34.5901V11.8174H10.1361C14.9657 11.8174 17.6161 15.0588 17.6161 18.9543C17.6161 22.8105 14.9261 26.053 10.1361 26.053H4.03451V34.589H0V34.5901ZM13.4786 18.9554C13.4786 16.7709 11.8611 15.3314 9.5845 15.3314H4.03451V22.5401H9.5845C11.8623 22.539 13.4786 21.1051 13.4786 18.9554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2349 34.5901V11.8174H35.9855V15.3303H24.266V21.2027H35.7477V24.7257H24.266V31.0772H35.9867V34.5901H20.2349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0641 34.5901L44.0625 18.3035V34.5901H40.0314V11.8174H44.1678L55.9202 27.589V11.8174H59.9547V34.5901H56.0641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5883 34.5901L78.9006 30.1863H68.3534L66.6657 34.5901H62.0796L71.1125 11.8174H76.1449L85.1778 34.5901H80.5883ZM73.627 15.8105L69.4905 26.6701H77.7623L73.627 15.8105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5564 34.5901V11.8174H105.102C112.309 11.8174 117.13 16.5286 117.13 23.1864C117.13 29.9137 112.309 34.5901 105.135 34.5901H96.5564ZM112.991 23.1864C112.991 18.8151 110.237 15.3303 105.135 15.3303H100.586V31.0772H105.101C110.104 31.0772 112.991 27.5217 112.991 23.1864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.604 34.5901V11.8174H136.357V15.3303H124.638V21.2027H136.12V24.7257H124.638V31.0772H136.357V34.5901H120.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4 34.5901V11.8174H156.155V15.3303H144.436V21.2027H155.915V24.7257H144.436V34.5901H140.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.321 34.5901V11.8174H163.356V34.5901H159.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.851 34.5901V11.8174H171.885V31.0772H182.018V34.5901H167.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.467 34.5901V11.8174H188.502V31.0772H198.636V34.5901H184.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.493 23.2178C199.493 16.4265 204.353 11.4404 211.246 11.4404C218.105 11.4404 223 16.4265 223 23.2178C223 30.0136 218.105 34.9997 211.246 34.9997C204.353 34.9997 199.493 30.0136 199.493 23.2178ZM218.862 23.2178C218.862 18.51 215.865 14.9881 211.245 14.9881C206.594 14.9881 203.626 18.51 203.626 23.2178C203.626 27.8976 206.592 31.4497 211.245 31.4497C215.865 31.4497 218.862 27.8976 218.862 23.2178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_397_318",
    x1: 59.9554,
    y1: 2.36232,
    x2: 201.285,
    y2: 2.36232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33d3046a1cd958f6a78cc130f102f447.svg";
export { ForwardRef as ReactComponent };